import React from 'react'
import { useTranslation } from 'react-i18next'
import Part from '../../../components/HomePart'
import icon1 from '../../../assets/img/ab-icon-1.png'
import icon2 from '../../../assets/img/ab-icon-2.png'
import icon3 from '../../../assets/img/ab-icon-3.png'
import Glass from '../../../components/Glass'
import './style.scss'

interface AbilityProp {
  icon: string
  text: string
}

const Ability: React.FC<AbilityProp> = ({ icon, text }) => {
  return (
    <div className="ability">
      <Glass className="icon">
        <img src={icon} alt="" />
      </Glass>
      <div className="text">{text}</div>
    </div>
  )
}

const Abilities: React.FC = () => {
  const { t } = useTranslation('trans', { keyPrefix: 'abilities' })

  return (
    <Part id="abilities" title={t('title')}>
      <div className="icons">
        <Ability icon={icon1} text={t('icon1')} />
        <Ability icon={icon2} text={t('icon2')} />
        <Ability icon={icon3} text={t('icon3')} />
      </div>
    </Part>
  )
}

export default Abilities
